import React, { PureComponent } from 'react';
import './AutoScrollingContainer.css';

export default class AutoScrollingContainer extends PureComponent {
  state = {
    scrollWidth: 0
  };

  componentDidMount() {
    this.refresh();

    if ('ResizeObserver' in global) {
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.wrapperElement);
    }
  }

  componentWillUnmount() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  componentDidUpdate(prevProps) {
    this.refresh();
  }

  refresh = () => {
    const { width: titleWidth } = this.contentsElement.getBoundingClientRect();
    const { width: wrapperWidth } = this.wrapperElement.getBoundingClientRect();
    const scrollWidth = Math.max(0, titleWidth - wrapperWidth);

    if (this.animation) this.animation.cancel();
    if (!scrollWidth || !this.contentsElement.animate) return;

    const PIXELS_TO_SCROLL_PER_SECOND = 24;
    const scrollDuration = Math.round(
      (scrollWidth / PIXELS_TO_SCROLL_PER_SECOND) * 1000
    );
    const duration = 2000 + scrollDuration;
    const offset = 1000 / duration;
    this.animation = this.contentsElement.animate(
      [
        {
          transform: `translateX(0)`,
          offset: 0
        },

        {
          transform: `translateX(0)`,
          offset
        },

        {
          transform: `translateX(${-scrollWidth}px)`,
          offset: 1 - offset
        },

        {
          transform: `translateX(${-scrollWidth}px)`,
          offset: 1
        }
      ],
      {
        duration,
        iterations: Infinity,
        direction: 'alternate'
      }
    );
  };

  handleContentsElementRef = contentsElement =>
    (this.contentsElement = contentsElement);
  handleWrapperElementRef = wrapperElement =>
    (this.wrapperElement = wrapperElement);

  render() {
    const { children, className = '', ...rest } = this.props;
    return (
      <div className={`AutoScrollingContainer ${className}`}>
        <div
          className="AutoScrollingContainer__contents-wrapper"
          ref={this.handleWrapperElementRef}
          {...rest}
        >
          <div
            className="AutoScrollingContainer__contents"
            ref={this.handleContentsElementRef}
          >
            {children}
          </div>
        </div>
      </div>
    );
  }
}
